module.exports = __webpack_public_path__ + "img/拥抱.5c59172d.png";